export class Fristen {
  constructor({
    id,
    erinnerungenAm,
  }: {
    id: string;
    erinnerungenAm: Erinnerungen[];
  }) {
    this.id = id;
    this.erinnerungenAm = erinnerungenAm;
  }

  id: string;
  erinnerungenAm: Erinnerungen[];
}

export class Erinnerungen {
  constructor({
    id,
    datum,
    managerId,
  }: {
    id: string;
    datum: string;
    managerId: string;
  }) {
    this.id = id;
    this.datum = datum;
    this.managerId = managerId;
  }

  id: string;
  datum: string;
  managerId: string;
}
